import { MissingFieldsList } from "@/components/submissions/MissingFieldsList";
import type { MissingField } from "@/lib/brokerProducts";

// A structured quote-readiness 400 rendered as a checklist with a route back to
// the profile form (BRK-S057) — mirrors AccountForm, never a raw string. Shared
// by the comparison's columns and each carrier's questions section (BRK-S290),
// where Great American's questions, assembled at the quote stage, name the
// county and employee counts they need (PMS-S660).
export function MissingFieldsNotice({
  missing,
  onCompleteProfile,
  missingFieldHref,
}: {
  missing: MissingField[];
  onCompleteProfile?: () => void;
  missingFieldHref?: (field: MissingField) => string | null;
}) {
  return (
    <div
      role="status"
      className="flex flex-col gap-1 text-xs font-normal text-brk-dim"
    >
      <span>A few more insured details are needed to quote:</span>
      <MissingFieldsList
        missing={missing}
        missingFieldHref={missingFieldHref}
      />
      {onCompleteProfile && !missingFieldHref && (
        <button
          type="button"
          onClick={onCompleteProfile}
          className="self-start text-brk-accent hover:underline"
        >
          Complete the insured profile
        </button>
      )}
    </div>
  );
}
